import { dayjs, displayDate, DateFormats } from "~/utils/date.utils";

export const currentYearMonth = (): string => displayDate(new Date(), DateFormats.YEAR_MONTH_ISO);

export const monthsAgoYearMonth = (months: number): string =>
  displayDate(dayjs().subtract(months, "month").toDate(), DateFormats.YEAR_MONTH_ISO);

export const startOfYearYearMonth = (): string => displayDate(dayjs().startOf("year").toDate(), DateFormats.YEAR_MONTH_ISO);

export const asCurrency = (value?: number | null): string =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value ?? 0);

export const asPercent = (value?: number | null): string => `${((value ?? 0) * 100).toFixed(1)}%`;

export const asCount = (value?: number | null): string => (value ?? 0).toLocaleString("pt-BR");

export const asDecimal = (value?: number | null): string =>
  (value ?? 0).toLocaleString("pt-BR", { maximumFractionDigits: 1 });

export const compactCurrency = (value?: number | null): string => {
  const safeValue = value ?? 0;
  if (safeValue >= 1_000_000) return `R$ ${(safeValue / 1_000_000).toFixed(1)}M`;
  if (safeValue >= 1_000) return `R$ ${(safeValue / 1_000).toFixed(0)}K`;
  return `R$ ${safeValue.toFixed(0)}`;
};

export const formatYearMonth = (key: string): string => displayDate(key, DateFormats.MONTH_YEAR_SHORT);

export const getMonthsInRange = (from: string, to: string): string[] => {
  const months: string[] = [];
  let current = dayjs(from, DateFormats.YEAR_MONTH_ISO);
  const end = dayjs(to, DateFormats.YEAR_MONTH_ISO);
  while (current.isBefore(end) || current.isSame(end, "month")) {
    months.push(displayDate(current.toDate(), DateFormats.YEAR_MONTH_ISO));
    current = current.add(1, "month");
  }
  return months;
};


